module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/news/news.component.html
// module id = ../../../../../src/app/admin/page/news/news.component.html
// module chunks = main